module.exports = __webpack_public_path__ + "static/media/Slide-1.a142a39b.png";